import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { DataGridPro, GridToolbar } from '@mui/x-data-grid-pro';
import { format, parseISO } from 'date-fns';
import Link from '@mui/material/Link';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import EditIcon from '@mui/icons-material/Edit'; 

import Loading from '../../common/Loading';
import Error from '../../common/Error';

import { useSessionContext } from '../../../contexts/SessionContext';

export default function PickupRequestsEditProjectsLookup(props){
    //console.debug("RTS Break PickupRequestsEditProjectsLookup");

    const {user, sessionCustomer, userAuthToken, apiRoot, userLogOut} = useSessionContext();

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));

    const formatObj = new Intl.DateTimeFormat("en-US");    

    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    const [selectionModel, setSelectionModel] = useState([]);

    const [data, setData] = useState([]);


    const fetchData = useCallback((pFilter) => {
        setIsLoading(true);
        let apiURL = apiRoot + "/Projects/GetProjectsSummary";
        axios
        .post(
            apiURL,
            pFilter, 
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                setIsLoading(false);
                setData(response.data);
            }
        })
        .catch(error => {
            setIsLoading(false);

            if(error.status == 401){
                userLogOut();
            }
            else{
                setHasError(true);
                console.log("RTS Data Error", error);
            }
        });
    },[apiRoot, userAuthToken.token]); 
    
    
    useEffect(() => {
        fetchData({user:user, customer:sessionCustomer.customer, manager:null, status:-1, sortBy:0})
    }, [props, user, sessionCustomer, fetchData]); 

    
    function handleClick(e, cellValues){
        props.setProjectInfoFx(cellValues.row);
    }


    const columns = [
        {
            field: 'Edit',
            headerName: '',
            description:"Edit Project", 
            flex:1,
            maxWidth:60,
            renderCell: (cellValues) => {
                return (
                    <Box sx={{display:'flex', alignItems:'center', justifyContent:'center', alignContent:'center', pt:.5}}>
                        <Link onClick={(event) => {handleClick(event, cellValues);}} sx={{textDecoration:'none', cursor:'pointer'}}>
                            <EditIcon />
                        </Link>
                    </Box>
                );
            },
            align:"center",
            sortable:false,
            filterable:false,
            hideable:false,
            disableColumnMenu:true
        },
        {
            field: 'name', 
            headerName: "Project Name", 
            description:"Project Name", 
            flex:4,
            hideable:false,
        },
        {
            field: 'managerName', 
            headerName: "Manager", 
            description:"Project Manager", 
            flex:3        
        },
        {
            field: 'loadCount', 
            headerName: "# Reels", 
            description:"Number of Reels",
            type: 'number', 
            flex:1    
        }, 
        {
            field: 'status', 
            headerName: "Status", 
            description:"Project Status",
            flex:2,    
            renderCell: (cellValues) => {
                if(cellValues.value === 0){
                    return ('Planning');
                }
                else if(cellValues.value === 50){
                    return('Started');
                }
                else{
                    return('Complete');
                }
            },     
        }, 
        {
            field: 'startDate', 
            headerName: "Start Date", 
            description:"Project Start Date", 
            type: 'date',
            flex:2,
            valueGetter: (value, row) => {
                if(value == null){
                    return null;
                }

                return (
                    new Date(value)
                );
            },
            type:"date",
            valueFormatter: (value) => {
                if(value == null){
                    return null;
                }
                
                const formatObj = new Intl.DateTimeFormat("en-US");
                return (
                    formatObj.format(new Date(value))
                );
            },
        },
    ];


    function getVisibilityModel(){
        if(smallForm){
            return {managerName:false, loadCount:false, startDate:false}
        }
        else{
            return {}
        }
    };


    function getDensity(){
        if(smallForm){
            return "comfortable";
        }
        else{
            return "standard";
        }
    };


    if(hasError){
        return(
            <Error />
        );
    }
    
    
    if(isLoading){
        return(
            <Loading />
        );
    }        


    return (
        <Box>
            <Box sx={{height:"400px"}}>
                <DataGridPro 
                    pagination
                    disableColumnFilter
                    slots={{toolbar: GridToolbar}}
                    slotProps={{
                        toolbar:{
                            showQuickFilter:true,
                            printOptions: { disableToolbarButton: true },
                            csvOptions: { disableToolbarButton: true },                        
                        }
                    }}                    
                    rows={data} 
                    columns={columns} 
                    getRowId={row => row.idGuid}
                    onRowSelectionModelChange={(newSelectionModel) => {
                        setSelectionModel(newSelectionModel);
                    }}
                    selectionModel={selectionModel}
                    initialState={{
                        columns:{
                            columnVisibilityModel: getVisibilityModel()
                        },
                        pagination: { paginationModel: { pageSize: 50 } },
                        density: getDensity() 
    
                    }}                          
                />
            </Box>

            <Box sx={{mt:2, textAlign:'right'}}>
                <Button variant="contained" onClick={e => {props.setShowProjectsModalFx(false);}}>Cancel</Button>
            </Box>
        </Box>
    );
}
